<template>
  <v-app>
    <AgrPlatformMarker />
    <AgrCheckBrowser v-model="isBrowserCompatible" />
    <AgrCheckVersion />
    <template v-if="isBrowserCompatible">
      <router-view />
    </template>
    <BaseNavigationLoader v-show="showLoader" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import bowser from 'bowser'

import BaseNavigationLoader from '@/components/common/base-navigation-loader.vue'
import { AgrCheckBrowser, AgrPlatformMarker, AgrCheckVersion  } from '@agrial/ui'
export default {
  components: {
    BaseNavigationLoader, AgrCheckBrowser, AgrPlatformMarker, AgrCheckVersion
  },
  data () {
    return {
      isBrowserCompatible: true
    }
  },
  computed: {
    ...mapGetters({
      showLoader: 'navigation/pending'
    })
  },
  created () {
    const browser = bowser.getParser(window.navigator.userAgent)
        /**
    * Retourne true si le navigateur utilisé à une version inférieure.
    */
    this.isBrowserCompatible = browser.satisfies({
        chrome: '>=63',
        safari: '>=11.1',
        firefox: '>=67',
        edge: '>=79',
        opera: '>=50',
        samsungBrowser: '>=8.2',
        ios: '>=11.3',
        'Samsung Internet for Android': '>=8'
      })
  }
}
</script>
